const timezones = [
  {
    text: "(GMT-10:00) Hawaiian/Aleutian Time",
    value: "Pacific/Honolulu"
  },
  {
    text: "(GMT-09:00) Alaska Time",
    value: "America/Anchorage"
  },
  {
    text: "(GMT-08:00) Pacific Time (US)",
    value: "America/Los_Angeles"
  },
  {
    text: "(GMT-07:00) Mountain Time (Arizona)",
    value: "America/Phoenix"
  },
  {
    text: "(GMT-07:00) Mountain Time (US)",
    value: "America/Denver"
  },
  {
    text: "(GMT-06:00) Central Time (US)",
    value: "America/Chicago"
  },
  {
    text: "(GMT-05:00) Eastern Time (US)",
    value: "America/New_York"
  },
  {
    text: "-------------",
    value: "--SEPARATOR1--"
  },
  {
    text: "(GMT-06:00) Central Time (Indiana)",
    value: "America/Indiana/Knox"
  },
  {
    text: "(GMT-05:00) Eastern Time (Indiana)",
    value: "America/Indiana/Indianapolis"
  },
  {
    text: "-------------",
    value: "--SEPARATOR2--"
  },
  {
    text: "(GMT-06:00) Central Time (Saskatchewan)",
    value: "America/Regina"
  },
  {
    text: "(GMT-06:00) Central Time (Mexico City, Monterey)",
    value: "America/Monterrey"
  },
  {
    text: "(GMT-05:00) UTC/GMT -5 hours",
    value: "America/Lima"
  },
  {
    text: "(GMT-04:00) Atlantic Time",
    value: "America/Manaus"
  },
  {
    text: "(GMT-04:00) Atlantic Time (Puerto Rico)",
    value: "America/Puerto_Rico"
  },
  {
    text: "(GMT-04:00) Western Greenland Time",
    value: "America/Thule"
  },
  {
    text: "(GMT-02:00) Eastern Brazil",
    value: "America/Sao_Paulo"
  },
  {
    text: "(GMT-03:30) Newfoundland Time",
    value: "America/St_Johns"
  },
  {
    text: "(GMT-03:00) Central Greenland Time",
    value: "America/Godthab"
  },
  {
    text: "(GMT-02:00) GMT-2:00",
    value: "Etc/GMT+2"
  },
  {
    text: "(GMT-01:00) Eastern Greenland Time",
    value: "America/Scoresbysund"
  },
  {
    text: "(GMT+00:00) Western European Time (Iceland)",
    value: "Atlantic/Reykjavik"
  },
  {
    text: "(GMT+00:00) UTC",
    value: "UTC"
  },
  {
    text: "(GMT+00:00) British Time (London)",
    value: "Europe/London"
  },
  {
    text: "(GMT+01:00) GMT+1:00",
    value: "Etc/GMT-1"
  },
  {
    text: "(GMT+00:00) Western European Time (Lisbon)",
    value: "Europe/Lisbon"
  },
  {
    text: "(GMT+01:00) Western European Time",
    value: "Europe/Paris"
  },
  {
    text: "(GMT+01:00) Central European Time",
    value: "Europe/Berlin"
  },
  {
    text: "(GMT+02:00) Eastern European Time",
    value: "Europe/Bucharest"
  },
  {
    text: "(GMT+02:00) South Africa Standard Time",
    value: "Africa/Johannesburg"
  },
  {
    text: "(GMT+03:00) Eastern Africa Time",
    value: "Africa/Kampala"
  },
  {
    text: "(GMT+03:00) Moscow",
    value: "Etc/GMT-3"
  },
  {
    text: "(GMT+03:00) Turkey Standard Time",
    value: "Etc/GMT-3"
  },
  {
    text: "(GMT+03:30) Iran Standard Time",
    value: "Asia/Tehran"
  },
  {
    text: "(GMT+04:00) UAE (Dubai)",
    value: "Asia/Dubai"
  },
  {
    text: "(GMT+05:00) Pakistan Standard Time (Karachi)",
    value: "Asia/Karachi"
  },
  {
    text: "(GMT+05:30) India",
    value: "Asia/Kolkata"
  },
  {
    text: "(GMT+06:00) Bangladesh Standard Time",
    value: "Asia/Dhaka"
  },
  {
    text: "(GMT+07:00) Western Indonesian Time (Jakarta)",
    value: "Asia/Jakarta"
  },
  {
    text: "(GMT+07:00) Thailand (Bangkok)",
    value: "Asia/Bangkok"
  },
  {
    text: "(GMT+08:00) Hong Kong",
    value: "Asia/Hong_Kong"
  },
  {
    text: "(GMT+08:00) Singapore",
    value: "Asia/Singapore"
  },
  {
    text: "(GMT+08:00) Australian Western Time",
    value: "Australia/West"
  },
  {
    text: "(GMT+09:00) Tokyo",
    value: "Asia/Tokyo"
  },
  {
    text: "(GMT+09:30) Australian Central Time (Northern Territory)",
    value: "Australia/North"
  },
  {
    text: "(GMT+10:30) Australian Central Time (Adelaide)",
    value: "Australia/Adelaide"
  },
  {
    text: "(GMT+10:00) Australian Eastern Time (Queensland)",
    value: "Australia/Queensland"
  },
  {
    text: "(GMT+11:00) Australian Eastern Time (Sydney)",
    value: "Australia/Sydney"
  },
  {
    text: "(GMT+11:00) Noumea, New Caledonia",
    value: "Pacific/Noumea"
  },
  {
    text: "(GMT+11:00) Norfolk Island (Austl.)",
    value: "Pacific/Norfolk"
  },
  {
    text: "(GMT+12:00) Tarawa",
    value: "Pacific/Tarawa"
  },
  {
    text: "(GMT+13:00) New Zealand Time",
    value: "Pacific/Auckland"
  }
];

export default {
  methods: {
    getTimezoneOptions() {
      return timezones;
    }
  }
};
